import { Tabs } from "antd";
import React from "react";

import { ExportOutlined, SubnodeOutlined } from "@ant-design/icons";
import TransformIcon from "../../components/icons/Transform";
import WarehouseExport from "./WarehouseExport";
import TransferWarehouseExport from "./WarehouseExportTransfer";
import WarehouseTransfer from "./WarehouseTransfer";

const WarehouseExportOptions: React.FC = () => {
  const items = [
    {
      key: "direct",
      label: (
        <>
          <ExportOutlined style={{ marginRight: 8 }} />
          <span>Xuất kho trực tiếp</span>
        </>
      ),
      children: <WarehouseExport />,
    },
    {
      key: "transfer-export",
      label: (
        <>
          <SubnodeOutlined style={{ marginRight: 8 }} />
          <span>Điều chuyển kho xuất</span>
        </>
      ),
      children: <WarehouseTransfer />,
    },
    {
      key: "transfer",
      label: (
        <>
          <TransformIcon style={{ marginRight: 8 }} />
          <span>Xuất luân chuyển kho</span>
        </>
      ),
      children: <TransferWarehouseExport />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="direct"
      items={items}
      size="large"
      type="card"
      className="p-4"
    />
  );
};

export default WarehouseExportOptions;
